module.exports = __webpack_public_path__ + "img/01_cg.1715d0c6.png";